/**
 * TrialMetrics - Trial & Conversion Metrics section
 */
import React from 'react';
import { UserCheck, UserX, Target, DollarSign, BarChart3, TrendingUp, Users } from 'lucide-react';
import { MetricCard, MetricSection, MetricSubsection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function TrialMetrics({ snapshotData }) {
  const summary = snapshotData?.summary || {};
  
  return (
    <MetricSection title="Trial & Conversion Metrics">
      {/* Current Trial Status */}
      <MetricSubsection title="Current Trial Status">
        <MetricGrid cols={4}>
          <MetricCard
            icon={UserCheck}
            iconColor="bg-blue-100 dark:bg-blue-900/20"
            title="Trial Users"
            value={formatValue(summary.trialUsers || 0, 'number')}
            subtitle="currently in trial"
          />
          <MetricCard
            icon={UserX}
            iconColor="bg-orange-100 dark:bg-orange-900/20"
            title="Non-Renewing Trial Users"
            value={formatValue(summary.totalNonRenewingTrialUsers || 0, 'number')}
            subtitle="won't convert"
            subtitleColor="text-orange-600 dark:text-orange-400"
          />
          <MetricCard
            icon={Target}
            iconColor="bg-green-100 dark:bg-green-900/20"
            title="Potential Conversions"
            value={formatValue((summary.trialUsers || 0) - (summary.totalNonRenewingTrialUsers || 0), 'number')}
            subtitle="could still convert"
            subtitleColor="text-green-600 dark:text-green-400"
          />
          <MetricCard
            icon={DollarSign}
            iconColor="bg-purple-100 dark:bg-purple-900/20"
            title="Potential Revenue"
            value={formatValue(((summary.trialUsers || 0) - (summary.totalNonRenewingTrialUsers || 0)) * (summary.averageRevenuePerUser || 0), 'currency')}
            subtitle="if all convert"
            subtitleColor="text-purple-600 dark:text-purple-400"
          />
        </MetricGrid>
      </MetricSubsection>

      {/* Conversion Performance */}
      <MetricSubsection title="Conversion Performance">
        <MetricGrid cols={4}>
          <MetricCard
            icon={Target}
            iconColor="bg-emerald-100 dark:bg-emerald-900/20"
            title="Trial Conversion"
            value={formatValue(summary.trialToPayConversionRate || 0, 'percentage')}
            subtitle="of trial users converted"
          />
          <MetricCard
            icon={BarChart3}
            iconColor="bg-blue-100 dark:bg-blue-900/20"
            title="Trial Conv. Pre-Increase"
            value={formatValue(summary.prePriceIncreaseConversionRate || 0, 'percentage')}
            subtitle={`${summary.prePriceIncreaseConversions || 0}/${summary.prePriceIncreaseTrialUsers || 0} converted`}
          />
          <MetricCard
            icon={TrendingUp}
            iconColor="bg-green-100 dark:bg-green-900/20"
            title="Trial Conv. Post-Increase"
            value={formatValue(summary.postPriceIncreaseConversionRate || 0, 'percentage')}
            subtitle={`${summary.postPriceIncreaseConversions || 0}/${summary.postPriceIncreaseTrialUsers || 0} converted`}
          />
          <MetricCard
            icon={Users}
            iconColor="bg-purple-100 dark:bg-purple-900/20"
            title="Lifetime Trial Users"
            value={formatValue(summary.lifetimeTrialUsers || 0, 'number')}
            subtitle="ever started a trial"
          />
        </MetricGrid>
      </MetricSubsection>
    </MetricSection>
  );
}

